import { Maybe } from 'graphql/jsutils/Maybe';

const formatMonths = (months: number): string => `${months} months`;
const formatYears = (months: number): string => `${Math.floor(months / 12)} years`;
const formatYearsWithPlus = (months: number): string => `${Math.floor(months / 12)}+ years`;

export const activityAgesToRangeText = (
  minAgeMonths?: Maybe<number>,
  maxAgeMonths?: Maybe<number>
): string | null => {
  if (!minAgeMonths && !maxAgeMonths) {
    return 'All ages';
  }

  if (!maxAgeMonths) {
    return minAgeMonths! < 12 ? `${minAgeMonths}+ months` : formatYearsWithPlus(minAgeMonths!);
  }

  if (!minAgeMonths) {
    return maxAgeMonths <= 12
      ? `Up to ${formatMonths(maxAgeMonths)}`
      : `Up to ${formatYears(maxAgeMonths)}`;
  }

  if (minAgeMonths === maxAgeMonths) {
    return minAgeMonths < 12 ? formatMonths(minAgeMonths) : formatYears(minAgeMonths);
  }

  const minInYears = Math.floor(minAgeMonths / 12);
  const maxInYears = Math.floor(maxAgeMonths / 12);

  if (minAgeMonths < 12 && maxAgeMonths < 12) {
    return `Ages ${minAgeMonths}-${maxAgeMonths} months`;
  }

  if (minAgeMonths < 12) {
    return `${formatMonths(minAgeMonths)} - ${formatYears(maxAgeMonths)}`;
  }

  return `Ages ${minInYears}-${maxInYears} years`;
};
